<template>
  <div>
    <div class="topBack">
      <i class="iconfont iconback" @click="onTopBack" />
    </div>
    <img src="/img/hbup.jpg" class="back">
    <div class="downRect">
      <img src="/img/hbdown.jpg" class="back">
      <div class="Body">
        <div v-if="teamId" class="title">加入潜水小队</div>
        <van-button v-if="teamId" class="buttonReg" type="info" :loading="buttonLoading" square @click="onJoinTeam">加入第{{ teamId }}小队，免费领取叮叮棒！</van-button>

        <div class="title">创建我的小队</div>
        <div class="input" style="margin-top: 0.5em;">
          <i class="iconfont iconrotate" @click="onRandomDeclaration" />
          <input v-model="declaration" readonly maxlength="20" placeholder="请选择小队宣言">
        </div>
        <van-button class="buttonReg" type="info" :loading="buttonLoading" square @click="onCreateTeam" disabled>创建小队，免费领取叮叮棒！[已结束]</van-button>

        <div class="emptyRect" />
      </div>
    </div>

  </div>
</template>
<script>
import request from '@/utils/request'
import { getUrlKey, randomNum, MyNotify } from '@/utils/base'
import { Button, Dialog } from 'vant'
import Cookies from 'js-cookie'
export default {
  components: {
    [Button.name]: Button,
    [Dialog.name]: Dialog

  },
  data() {
    return {
      backurl: '/activity/groupReg',
      buttonLoading: false,
      teamId: undefined,
      declaration: undefined,
      declarationList: [
        '与海共生',
        '拒绝过度使用塑料',
        '感谢你每次点外卖选择的“无需餐具”',
        '别对地球71%的世界一无所知',
        '保护海洋人人有责',
        '热爱海洋，保护海洋濒危物种',
        '与珍惜海洋，珍爱生命共生',
        '保护海洋，从成为一名潜水员做起',
        '每一个潜水员都是海洋的保护者',
        '拥抱蓝色海洋，珍爱生命摇篮',
        '关爱海洋，从潜水员行动起来'
      ]
    }
  },
  mounted() {
    console.log('进入')
    document.getElementsByTagName('body')[0].className = 'activeBacl'
  },
  destroyed: function() {
    console.log('离开')
    document.body.removeAttribute('class', 'activeBacl')
  },
  created() {
    this.teamId = Cookies.get('activityCardKey_')
    var url = getUrlKey('backurl')
    if (url !== null) {
      this.backurl = url
    }

    this.declaration = Cookies.get('activityDeclaration_')
    if (!this.declaration) {
      // this.onRandomDeclaration()
    }
  },
  methods: {
    onTopBack() {
      this.$router.replace(this.backurl)
    },
    GetApproveState(callback) {
      request({
        url: '/Activity/GetApproveState',
        method: 'post'
      }).then(Response => {
        if (!Response.success) {
          if (callback) {
            callback(undefined)
          }
          return
        }
        if (callback) {
          callback(Response.data)
        }
      })
    },
    onRandomDeclaration() {
      var rid = randomNum(0, this.declarationList.length - 1)
      var newStr = this.declarationList[rid]
      while (newStr === this.declaration) {
        rid = randomNum(0, this.declarationList.length - 1)
        newStr = this.declarationList[rid]
      }
      this.declaration = newStr
      Cookies.set('activityDeclaration_', this.declaration)
    },
    onJoinTeam() {
      var my = this
      this.buttonLoading = true
      this.GetApproveState((data) => {
        if (!data) {
          my.buttonLoading = false
          my.$router.replace('/activity/group')
          return
        }
        switch (data.verifyType) {
          case 'WAIT':
            Dialog.alert({
              title: '潜水员身份审核中',
              message: '您的资质正在审核中,前面还有' + data.needApproveNum + '人!(非工作时间请次日查看结果!)' })
            my.buttonLoading = false
            return
          case 'CANCEL':
            Dialog.confirm({
              title: '潜水员身份审核失败',
              message: '非常抱歉，您的潜水员资质审核失败，原因:' + data.verifyBody + ';是否要重新提交材料?' })
              .then(() => {
                my.$router.replace('/activity/groupReg')
              })
            my.buttonLoading = false
            return
        }
        // 如果通过了
        request({
          url: '/Activity/JoinCardTeam',
          method: 'get',
          params: {
            id: this.teamId
          }
        }).then(Response => {
          my.buttonLoading = false
          if (!Response.success) {
            return
          }
          if (Response.data) {
            Dialog.confirm({
              title: '加入小队失败',
              message: '您已经在小队中了，无法加入其他小队！查看我所在的小队？' })
              .then(() => {
                Cookies.remove('activityCardKey_')
                my.$router.replace('/activity/groupTeams')
              })
            return
          } else {
            Cookies.remove('activityCardKey_')
            MyNotify('success', '加入小队成功，快邀请其他小伙伴加入吧！')
            my.$router.replace('/activity/groupTeams')
          }
        })
      })
    },
    onCreateTeam() {
      if (!this.declaration || this.declaration.length <= 0) {
        MyNotify('info', '请选择宣言')
        return
      }
      var my = this
      this.buttonLoading = true
      this.GetApproveState((data) => {
        if (!data) {
          my.buttonLoading = false
          my.$router.replace('/activity/group')
          return
        }
        switch (data.verifyType) {
          case 'WAIT':
            Dialog.alert({
              title: '潜水员身份审核中',
              message: '您的资质正在审核中,前面还有' + data.needApproveNum + '人!(非工作时间请次日查看结果!)' })
            my.buttonLoading = false
            return
          case 'CANCEl':
            Dialog.confirm({
              title: '潜水员身份审核失败',
              message: '非常抱歉，您的潜水员资质审核失败，原因:' + data.verifyBody + ';是否要重新提交材料?' })
              .then(() => {
                my.$router.replace('/activity/groupReg')
              })
            my.buttonLoading = false
            return
        }
        // 如果通过了
        request({
          url: '/Activity/CreateCardTeam',
          method: 'post',
          data: {
            declaration: this.declaration
          }
        }).then(Response => {
          my.buttonLoading = false
          if (!Response.success) {
            return
          }
          if (Response.data) {
            Dialog.confirm({
              title: '创建小队失败',
              message: '您已经在小队中了，无法新建小队！查看我所在的小队？' })
              .then(() => {
                Cookies.remove('activityCardKey_')
                my.$router.replace('/activity/groupTeams')
              })
            return
          } else {
            MyNotify('success', '小队创建成功，快邀请小伙伴加入吧！')
            Cookies.remove('activityCardKey_')
            my.$router.replace('/activity/groupTeams')
          }
        })
      })
    }
  }
}
</script>
<style scoped>
.topBack{
   z-index: 100;
  position: absolute;
  left:1em;
  top: 1em;
  color: #fff;
}
.back{
  width: 100%;
  margin: 0;
  padding: 0;
  vertical-align:top;
}
.downRect{
  position: relative;
}
.Body{
  padding: 0 2em;
  margin-top: 4em;
  color: #fff;
  position: absolute;;
  left: 0;
  right: 0;
  top:0;
  line-height: 1.5em;
  font-size: 0.9em;
}
.title{
  font-size: 1.1em;
  font-weight: 700;
  margin: 2em 0 1em 0;
}
.buttonReg{
  background-color: #0092FA;
  border: #0092FA;
  width: 100%;
}
.input{
    margin-bottom: 1em;
    position: relative;
    background-color: transparent;
    border: 1px solid #ccc;
    padding: 0 1em 0 4em;
}
.input i{
    position:absolute;
    left: 0;
    top:0;
    height: 2.5em;
    line-height: 2.5em;
    color: #Fff;
    text-align: center;
    width: 4em;
}
.input input{
     background-color: transparent;
         height: 2.5em;
    line-height: 2.5em;
    color: #Fff;
    width: 100%;
    border: none;
}
.emptyRect{
    height: 2em;
}
</style>
